import { useEffect, useState } from 'react';
import axios from 'axios';
import { allProductURL } from '../components/assets/constants/Urls/Url'; // Update this with the correct URL path if needed

const useFetchAllProducts = () => {
  const [productData, setProductData] = useState([]); // state to hold product data
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchAllProducts = async () => {
    setIsLoading(true);
    setError(null); // Reset error state


    try {
      // Fetch all products from the backend
      const response = await axios.get(allProductURL); // Ensure your URL matches the FetchAllProductsResource route
      if (response.data) {
        //console.log('Fetched data:', response.data); // Debug: Check structure of response
        setProductData(response.data); // Set fetched data to state
      }
      else{

        //console.log('No data found');
      }
    } catch (error) {
      setError(error); // Capture any errors
    } finally {
      setIsLoading(false); // End loading state
    }
  };

  useEffect(() => {
    fetchAllProducts(); // Fetch products on initial render
    //console.log('Product Data:', productData); // Log product data to confirm
    
  }, []);

  return {productData, isLoading, error}; // Return refetch function for manual reloads
};

export default useFetchAllProducts;
